module.exports = __webpack_public_path__ + "img/calendar.c63dfbe0.svg";